import Entities from 'STORE';

export function openAudioPlayer(groupId: string, messageId: string, payloadId: string): void {
  Entities.miniAudioPlayer.play(groupId, messageId, payloadId);
}
